<template>
  <el-dialog
    v-model="dialogVisible"
    width="60%"
    destroy-on-close
  >
    <Container
      :title="t('pay.selectAcceptanceReceiveBank')"
    >
      <template #main>
        <el-row class="subtitle-1">
          {{ t('pay.currentReceivingBank') }}
        </el-row>
        <el-row
          :gutter="10"
          class="subtitle-2"
        >
          <el-col :span="8">
            <span class="subtitle-3">{{ t('pay.bankCode') }}: </span>
            <span>{{ vendorBankCode }}</span>
          </el-col>
          <el-col :span="8">
            <span class="subtitle-3">{{ t('pay.bankName') }}: </span>
            <span>{{ vendorBankName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="subtitle-3">{{ t('pay.bankAccount') }}: </span>
            <span>{{ vendorBankAccount }}</span>
          </el-col>
        </el-row>
        <SimpleTableForSingleSelect
          ref="tableRef"
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :hadSelect="true"
          :hadOperate="false"
          :operateColumnWidth="240"
        />
        <el-form
          ref="cFormRef"
          label-position="left"
          style="margin-left:35%; font-size: 14px;"
        >
          <el-row :gutter="5">
            <el-col :span="24">
              <el-form-item
                label-width="50%"
                style="text-align: right; margin-top: 15px;"
              >
                <el-button
                  ref="opsButton"
                  class="order-button"
                  @click="handleCancel"
                >
                  {{ t('pay.cancel') }}
                </el-button>
                <el-button
                  ref="opsButton"
                  class="order-button"
                  type="primary"
                  @click="handleConfirm"
                >
                  {{ t('pay.confirm') }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
  </el-dialog>
</template>

<script lang="ts">
import { computed, defineComponent, nextTick, onMounted, PropType, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import SimpleTableForSingleSelect from '@/components/table/simple/SimpleTableForSingleSelect.vue'
import { SupplierBankModel } from '@/model/master-data/supplierModel'

export default defineComponent({
  name: 'AcceptancePaymentSelectVendorBankDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    vendorNumber: {
      type: String,
      default: ''
    },
    vendorBankAccount: {
      type: String,
      default: ''
    },
    vendorBankCode: {
      type: String,
      default: ''
    },
    vendorBankName: {
      type: String,
      default: ''
    },
    vendorBankList: {
      type: [] as PropType<Array<SupplierBankModel>>,
      required: true,
      default: () => {
        return []
      }
    }
  },
  components: { SimpleTableForSingleSelect, Container },
  emits: ['update:modelValue', 'confirm'],
  setup(props, context) {
    const { t } = useI18n()
    const tableRef = ref()
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const vendorBankTableStruct = [
      { prop: 'code', label: t('pay.bankCode') },
      { prop: 'name', label: t('pay.bankName') },
      { prop: 'account', label: t('pay.bankAccount') }
    ]
    const dataMap = reactive({
      listLoading: true,
      tableData: Array<SupplierBankModel>(),
      columnStruct: vendorBankTableStruct,
      defaultBankId: null as number | null,
      getVendorBankList() {
        dataMap.listLoading = true
        if (props && props.vendorBankList && props.vendorBankList.length > 0) {
          dataMap.tableData = props.vendorBankList
          const current = dataMap.tableData.find(v => v.account === props.vendorBankAccount)
          dataMap.defaultBankId = current ? current.id : null
          console.log(dataMap.defaultBankId)

          tableRef.value.setSelectedRow(dataMap.defaultBankId)
        } else {
          dataMap.tableData = []
        }
        tableRef.value.clearSelection()
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const handleCancel = () => {
      dialogVisible.value = false
    }
    const handleConfirm = async() => {
      if (dataMap.tableData.length === 0 || tableRef.value.getSelectionRow() === null || tableRef.value.getSelectionRow() === undefined) {
        ElMessage({
          message: t('pay.bankEmptyAlertMessage'),
          type: 'error',
          duration: 2000
        })
        return
      }
      const selectRow = tableRef.value.getSelectionRow()
      const bank = dataMap.tableData.find(d => d.id === selectRow)
      console.log('select bank', bank)
      context.emit('confirm', bank)
    }

    onMounted(() => {
      nextTick(() => {
        dataMap.getVendorBankList()
      })
    })
    return {
      t,
      tableRef,
      dialogVisible,
      handleCancel,
      handleConfirm,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.fixed-bottom-button {
  position: fixed;
  text-align: right;
  bottom: 40px; /* 距离底部的距离 */
  right: 20px; /* 距离右边的距离 */
}

.subtitle-1 {
  margin: 10px 0;
  font-weight: bold;
}

.subtitle-2 {
  margin: 10px 0;
}

.subtitle-3 {
  font-weight: bold;
}
</style>
